var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import InputWithOptions from '../InputWithOptions/InputWithOptions';
import InputWithTags from './InputWithTags';
import last from 'lodash/last';
import difference from 'difference';
import uniqueId from 'lodash/uniqueId';

var MultiSelect = function (_InputWithOptions) {
  _inherits(MultiSelect, _InputWithOptions);

  function MultiSelect(props) {
    _classCallCheck(this, MultiSelect);

    var _this = _possibleConstructorReturn(this, (MultiSelect.__proto__ || Object.getPrototypeOf(MultiSelect)).call(this, props));

    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onEnterPressed = _this.onEnterPressed.bind(_this);
    _this.onPaste = _this.onPaste.bind(_this);
    _this.state = { pasteDetected: false };

    console.warn('MultiSelect: onSelect signature should get an array of tags instead of single tag as parameter. Old signature will not be supported starting from 16/09/2017');
    return _this;
  }

  _createClass(MultiSelect, [{
    key: 'getUnselectedOptions',
    value: function getUnselectedOptions() {
      var optionIds = this.props.options.map(function (option) {
        return option.id;
      });
      var tagIds = this.props.tags.map(function (tag) {
        return tag.id;
      });
      var unselectedOptionsIds = difference(optionIds, tagIds);
      return this.props.options.filter(function (option) {
        return unselectedOptionsIds.includes(option.id);
      });
    }
  }, {
    key: 'dropdownAdditionalProps',
    value: function dropdownAdditionalProps() {
      return {
        options: this.getUnselectedOptions().filter(this.props.predicate),
        closeOnSelect: false
      };
    }
  }, {
    key: 'closeOnSelect',
    value: function closeOnSelect() {
      return false;
    }
  }, {
    key: 'inputAdditionalProps',
    value: function inputAdditionalProps() {
      return {
        inputElement: React.createElement(InputWithTags, null),
        onKeyDown: this.onKeyDown,
        onEnterPressed: this.onEnterPressed,
        delimiters: this.props.delimiters,
        onPaste: this.onPaste
      };
    }
  }, {
    key: 'onPaste',
    value: function onPaste() {
      this.setState({ pasteDetected: true });
    }
  }, {
    key: '_onChange',
    value: function _onChange(event) {
      var _this2 = this;

      if (!this.state.pasteDetected) {
        this.setState({ inputValue: event.target.value });
        this.props.onChange && this.props.onChange(event);
      } else {
        var delimitersRegexp = new RegExp(this.props.delimiters.join('|'), 'g');
        var value = event.target.value.replace(delimitersRegexp, ',');
        var tags = value.split(',').map(function (str) {
          return str.trim();
        }).filter(function (str) {
          return str;
        });

        this.clearInput();
        this.setState({ pasteDetected: false });

        var suggestedOptions = tags.map(function (tag) {
          var tagObj = _this2.getUnselectedOptions().find(function (element) {
            return _this2.props.valueParser(element).toLowerCase() === tag.toLowerCase();
          });
          return tagObj ? tagObj : { id: uniqueId('customOption_'), value: tag, theme: 'error' };
        });

        this.onSelect(suggestedOptions);
      }
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(option) {
      this.onSelect(option);
    }
  }, {
    key: '_onManuallyInput',
    value: function _onManuallyInput(inputValue) {
      if (inputValue) {
        inputValue = inputValue.trim();
        if (this.closeOnSelect()) {
          this.hideOptions();
        }

        this.onManuallyInput(inputValue);
      } else {
        _get(MultiSelect.prototype.__proto__ || Object.getPrototypeOf(MultiSelect.prototype), 'hideOptions', this).call(this);
      }
      this.clearInput();
    }
  }, {
    key: 'onEnterPressed',
    value: function onEnterPressed() {
      if (this.props.value.trim()) {
        var unselectedOptions = this.getUnselectedOptions();
        var visibleOptions = unselectedOptions.filter(this.props.predicate);
        var maybeNearestOption = visibleOptions[0];

        if (maybeNearestOption) {
          this.onSelect(maybeNearestOption);
        }

        this.clearInput();
      }
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      var _props = this.props,
          tags = _props.tags,
          value = _props.value,
          onRemoveTag = _props.onRemoveTag,
          delimiters = _props.delimiters;


      if (tags.length > 0 && (event.key === 'Delete' || event.key === 'Backspace') && value.length === 0) {
        onRemoveTag(last(tags).id);
      }

      if (event.key === 'Escape') {
        this.clearInput();
        _get(MultiSelect.prototype.__proto__ || Object.getPrototypeOf(MultiSelect.prototype), 'hideOptions', this).call(this);
      }

      if (event.key === 'Tab' || delimiters.includes(event.key)) {
        this.onEnterPressed();
      }

      if (this.props.onKeyDown) {
        this.props.onKeyDown(event);
      }
    }
  }, {
    key: 'optionToTag',
    value: function optionToTag(_ref) {
      var id = _ref.id,
          value = _ref.value,
          tag = _ref.tag,
          theme = _ref.theme;

      return tag ? _extends({ id: id }, tag) : { id: id, label: value, theme: theme };
    }
  }, {
    key: 'onSelect',
    value: function onSelect(options) {
      if (!Array.isArray(options)) {
        options = [options];
      }

      this.clearInput();

      if (this.props.onSelect) {
        options = options.map(this.optionToTag);
        if (options.length === 1) {
          this.props.onSelect(options[0]);
        } else {
          this.props.onSelect(options);
        }
      }

      this.input.focus();
    }
  }, {
    key: 'onManuallyInput',
    value: function onManuallyInput(inputValue) {
      if (!inputValue) {
        this.input.blur();
        return;
      }

      if (this.props.onManuallyInput) {
        this.props.onManuallyInput(this.optionToTag({ id: uniqueId('customOption_'), value: inputValue }));
      }

      this.clearInput();
    }
  }, {
    key: 'clearInput',
    value: function clearInput() {
      if (this.props.onChange) {
        this.props.onChange({ target: { value: '' } });
      }
    }
  }]);

  return MultiSelect;
}(InputWithOptions);

MultiSelect.propTypes = _extends({}, InputWithOptions.propTypes, {
  predicate: PropTypes.func,
  tags: PropTypes.array,
  delimiters: PropTypes.array
});

MultiSelect.defaultProps = _extends({}, InputWithOptions.defaultProps, {
  predicate: function predicate() {
    return true;
  },
  tags: [],
  delimiters: [',']
});

export default MultiSelect;
//# sourceMappingURL=MultiSelect.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MultiSelect/MultiSelect.js